<template>
  <div class="m-0 p-3 text-center"  >
    <img class="img-thumbnail" :src="imageFile"  alt="" v-if="!isImageUploading && imageFile !== null"
         style="height: 11rem;"
    />
    <img class="img-thumbnail" src="/assets/images/illustrations/placeholder.png" alt="" v-if="imageFile === null"
         style="height: 11rem;"/>
    <div v-if="isImageUploading" class="d-flex aligns-items-center justify-content-center mt-3">
      <b-spinner  class="spiner-center" type="grow" label="Loading..."></b-spinner>
    </div>
  </div>
</template>

<script>
import init from "@/core/mixins/init";

export default {
  name: 'PreviewField',
  mixins: [init],
  data(){
    return {
      imageFile: null,
      input: null,
      isImageUploading: false,
      errorImgSize: false
    }
  },
  watch:{
    imageIn(newVal) {
      if(newVal && typeof newVal === 'string'){
        this.imageFile = this.folder + newVal
      }
      if(newVal === null){
        this.imageFile = null
      }
      if(newVal instanceof File){
        this.hasValidationImage(newVal)
      }
    }
  },
  props: ['imageIn','folder'],
  methods:{
    hasValidationImage(image){
      var imgSize = image.size
      if(imgSize < 10485760){
        this.errorImgSize = false
        this.showImagePreview(image)
      }else {
        this.errorImgSize = true
      }
    },
    showImagePreview(image) {
      this.isImageUploading = true
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageFile = e.target.result;
      };
      reader.readAsDataURL(image);
      setTimeout(() => {
        this.isImageUploading = false
      }, 1000);
    }
  }
}
</script>

<style scoped>

</style>
